<mat-card class="pj-modal">
  <mat-card-title>
    Ajouter votre fichier
  </mat-card-title>
  <mat-card-content>
    <p8-attachments [application]="application"
                    [accept]="acceptFiles"
                    [maxFiles]="maxFiles"
                    [maxFileSize]="maxFileSize"
                    [connector]="uploadConnector"
                    [colorButton]="colorButton"
                    [typeButton]="typeFileButton"
                    [buttonIconAlign]="alignFilesUpload"
                    [uploading$]="uploading$"
                    (onFinished)="handleFinishUploadedFiles($event)"
                    (onUpdatedFiles)="hasAttachmentsToUpload($event)">
    </p8-attachments>

  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button color="primary"
            (click)="launchUpload()"
    >
      Sauvegarder
    </button>
    <button mat-raised-button
            (click)="closePopUp()"
    >
      Annuler
    </button>
  </mat-card-actions>
</mat-card>
